import { Reveal, SectionHeading } from "@/components/motion";
import { Scale, ShieldCheck, Radar } from "lucide-react";

const STAKES = [
  {
    icon: Scale,
    title: "Win delivery disputes",
    body: "When a customer says it never arrived, you don\u2019t argue. You hand back a signed, timestamped, location-verified record of what actually happened.",
    testid: "why-card-disputes",
  },
  {
    icon: ShieldCheck,
    title: "Give insurers evidence they\u2019ll accept",
    body: "Every verified event is sealed into a SHA-256 chained audit trail — built to survive claims review, legal review, and regulatory audit.",
    testid: "why-card-insurers",
  },
  {
    icon: Radar,
    title: "Catch fraud before payout",
    body: "Spoofed GPS, replayed tracks, and phantom deliveries are flagged at event time — before the claim is paid, not after.",
    testid: "why-card-fraud",
  },
];

const WhyProof = () => (
  <section data-testid="why-proof-section" className="border-b border-border">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
      <div className="grid lg:grid-cols-12 gap-12 mb-16">
        <div className="lg:col-span-6">
          <SectionHeading index="01" eyebrow="The Business Case" title="Why proof matters." />
        </div>
        <div className="lg:col-span-6 lg:pt-16 flex items-end">
          <Reveal delay={0.15}>
            <p className="text-base md:text-lg leading-relaxed text-muted-foreground max-w-xl">
              Most delivery stacks record what the driver said.{" "}
              <span className="text-foreground font-semibold">GeoVerify proves what happened</span> —
              and turns that proof into money saved on disputes, claims, and fraud.
            </p>
          </Reveal>
        </div>
      </div>
      <div className="grid md:grid-cols-3 border border-border md:divide-x divide-y md:divide-y-0 divide-border">
        {STAKES.map((s, i) => (
          <Reveal key={s.title} delay={0.1 + i * 0.12} className="h-full">
            <div
              data-testid={s.testid}
              className="h-full px-8 py-10 hover:bg-muted/40 transition-colors duration-300 group"
            >
              <s.icon className="w-6 h-6 text-telemetry mb-6 group-hover:scale-110 transition-transform duration-300" />
              <h3 className="font-display font-bold text-xl tracking-tight mb-3">{s.title}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyProof;
